import useTranslation from '../../states/translation/useTranslation';
import EligibilityWidgetTokenStatus from './EligibilityWidgetTokenStatus';

const EligibilityWidgetTokenIneligible: React.FC<React.PropsWithChildren> = (props) => {
  const { t } = useTranslation().actions;

  return (
    <EligibilityWidgetTokenStatus
      header={t('eligibility-widget.card.header.ineligible')}
      body={t('eligibility-widget.card.body.ineligible')}
      {...props}
    />
  );
};

export default EligibilityWidgetTokenIneligible;
